import React from "react";
import "@emran-alhaddad/saudi-riyal-font/index.css";
import "../../assets/dirham-symbol.css";

const CurrencySymbol = ({ currency, withParentheses = true }) => {
  const code = (currency || "").toUpperCase();

  if (code === "SAR") {
    return (
      <span className="currency-symbol">
        <span className="icon-saudi_riyal"></span>
      </span>
    );
  }

  if (code === "AED") {
    return (
      <span className="currency-symbol">
        <span className="dirham-symbol">&#xea;</span>
      </span>
    );
  }

  if (!currency) {
    return "";
  }

  return withParentheses ? ` (${currency})` : currency;
};

export default CurrencySymbol;
